import {  useSelector, useDispatch } from 'react-redux';
import FloatingLabelInput from "../../components/floatingLabelInput";
import FloatingLabelTextArea from "../../components/floatingLabelTextArea";
import { useEffect, useState } from 'react';
import { SubmitBusinessDetails, fetchInitialState, updateOfficeSpaceOtherBusinessOption } from './officeSpaceOtherBusinessSlice';
import Loader from '../../components/loader';
import { OptionCard, OptionCardRow, OptionCardSeparator, StepHeading, StepShell } from '../../components/optionCard';
import BusinessList from '../../components/businessList';
import { formatPhoneNumber, formatDollarWithComma } from '../utils';


const initialData = {
    name: '',
    industry: '',
    contactName: '',
    contactEmail: '',
    contactNumber: '',
    rentAmount: '',
    comments: '',
  }

const OfficeSpaceOtherBusinessDetails2 = () => {
    const dispatch = useDispatch();
    const officeSpaceOtherBusinessDetailsState = useSelector(state => state.other_businesses);
    const [data, setData] = useState(initialData);
    const [error, setError] = useState({
        contactEmail: '',
        contactNumber: '',
    })

    useEffect(() => {
        dispatch(fetchInitialState());
    },[dispatch])

    const handleFormSubmit = (e) => {
        e.preventDefault()
        const isFormValid = Object.values(error).every((error) => error === '');
    
        if (isFormValid) {
            dispatch(SubmitBusinessDetails(data)).then(() => setData(initialData));
        }
    }


    const handleFormChange = (e) => {
        const { name, value } = e.target;
        if (name === 'contactNumber') {
            const formattedPhoneNumber = formatPhoneNumber(value);
            setData({...data, [name]: formattedPhoneNumber});
            setError({...error, [name]: ''});
        }
        else if (name === 'contactEmail') {
            setData({...data, [name]: value})
            setError({...error, [name]: ''});
        }
        else if (name === 'rentAmount') {
            setData({...data, [name]: formatDollarWithComma(value)})
            setError({...error, [name]: ''});
        }
        else {
            setData({...data, [name]: value});
        }
    }

    const handleBlur = (e) => {
        const { name, value } = e.target;
        if (name === 'contactNumber') {
            // Check if the number has 10 digits
            const rawNumbers = value.replace(/[^\d]/g, '');
            if (rawNumbers.length !== 10) {
                setError({...error, [name]: 'Please enter a valid phone number'});
            }
        }
        else if (name === 'contactEmail') {
            var emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            if (!emailPattern.test(value)) {
                setError({...error, [name]: 'Please enter a valid email address'});
            }
        }
        
      };

    return (
        <>
            { officeSpaceOtherBusinessDetailsState.loading && <Loader /> }
            <StepShell>
                <StepHeading>
                    Do you share office space with any other business(es)?
                </StepHeading>
                <OptionCardRow>
                    {/* Yes Option */}
                    <OptionCard
                        selected={officeSpaceOtherBusinessDetailsState.data.office_space_detail._option === 'Yes'}
                        onClick={() => dispatch(updateOfficeSpaceOtherBusinessOption('Yes'))}
                    >
                        Yes
                    </OptionCard>

                    <OptionCardSeparator />

                    {/* No Option */}
                    <OptionCard
                        selected={officeSpaceOtherBusinessDetailsState.data.office_space_detail._option === 'No'}
                        onClick={() => dispatch(updateOfficeSpaceOtherBusinessOption('No'))}
                    >
                        No
                    </OptionCard>
                </OptionCardRow>


                { officeSpaceOtherBusinessDetailsState.data.office_space_detail._option === 'Yes' && (
                    <>
                        <div className="mt-10 flex flex-col items-center justify-center">
                            <h3 className="text-center text-lg font-semibold text-[#0a1445] sm:text-xl">
                            Enter the details for the business(es) you share office space with
                            </h3>
                        </div>
                        <div className="mx-auto mt-10 w-full max-w-4xl sm:mt-14">
                            <form onSubmit={handleFormSubmit}>
                                <div className="pb-12 space-y-12">
                                    <div className="grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-6">
                                        <div className="sm:col-span-2">
                                            <FloatingLabelInput 
                                                    handleChange={handleFormChange} 
                                                    value={data.name}
                                                    name="name" 
                                                    id="name" 
                                                    label="Business Name" 
                                                    required={true}
                                                />
                                        </div>
                                        <div className="sm:col-span-2">
                                            <FloatingLabelInput 
                                                    handleChange={handleFormChange} 
                                                    value={data.industry} 
                                                    name="industry" 
                                                    id="industry" 
                                                    label="Industry" 
                                                    required={true}
                                                />
                                        </div>
                                        <div className="sm:col-span-2">
                                            <FloatingLabelInput 
                                                    handleChange={handleFormChange} 
                                                    value={data.contactName} 
                                                    name="contactName" 
                                                    id="contactName" 
                                                    label="Contact Name" 
                                                    required={true}
                                                />
                                        </div>
                                    </div>
                                    <div className="mt-10 grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-6">
                                        <div className="sm:col-span-2">
                                            <FloatingLabelInput 
                                                    handleChange={handleFormChange} 
                                                    handleBlur={handleBlur}
                                                    value={data.contactEmail} 
                                                    error={error.contactEmail}
                                                    name="contactEmail" 
                                                    id="contactEmail" 
                                                    type="email" 
                                                    label="Contact Email" 
                                                    required={true}
                                                />
                                        </div>
                                        <div className="sm:col-span-2">
                                            <FloatingLabelInput 
                                                    handleChange={handleFormChange} 
                                                    handleBlur={handleBlur}
                                                    value={data.contactNumber} 
                                                    error={error.contactNumber}
                                                    name="contactNumber" 
                                                    id="contact_number" 
                                                    type="tel" 
                                                    label="Contact Number" 
                                                    required={true}
                                                />
                                        </div>
                                        <div className="sm:col-span-2">
                                            <FloatingLabelInput 
                                                    handleChange={handleFormChange} 
                                                    value={data.rentAmount} 
                                                    // error={managerDetailsState.formErrors.rentAmount}
                                                    name="rentAmount" 
                                                    id="rentAmount" 
                                                    type="text" 
                                                    label="How much rent do they pay ($)?" 
                                                    required={true}
                                                    isCurrency={true}
                                                />
                                        </div>
                                    </div>
                                    <div className="mt-10 grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-6">
                                        <div className="sm:col-span-6">
                                            <FloatingLabelTextArea 
                                                    handleChange={handleFormChange} 
                                                    value={data.comments} 
                                                    // error={managerDetailsState.formErrors.rentAmount}
                                                    name="comments" 
                                                    id="comments" 
                                                    label="Comments" 
                                                    // required={true}
                                                />
                                        </div>
                                    </div>
                                    
                                    <div className='flex items-center justify-center'>
                                        <button 
                                            className="bg-custom-purple text-white font-semibold px-4 py-2 rounded-full flex items-center justify-center min-w-40 min-h-12 ml-4"
                                            type='submit'
                                            >
                                            Add Business
                                        </button>
                                    </div>
                                </div>
                            </form>
                            {/* Business List */}
                            <BusinessList businesses={officeSpaceOtherBusinessDetailsState.data.related_businesses || []} />
                        </div>
                    </>
                )}
                
            </StepShell>
            
            
        </>

    )
}

export default OfficeSpaceOtherBusinessDetails2;
